var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",class:{ 'button--disabled': _vm.disabled },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.click.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }